module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10",
      "offset": "1"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_BAREME_MANAGEMENT', this.lang)))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('b-row', {
    staticClass: "syscoBox text-left"
  }, [_c('b-col', {
    staticClass: "text-white bg-evaobj pt-2",
    attrs: {
      "cols": "12",
      "id": "testContent"
    }
  }, [_c('h5', [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.$t('LNG_EVALUATION_INFORMATION', this.lang)))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "cols": "12",
      "id": "testContent"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('LNG_NAME', this.lang)) + ": " + _vm._s(this.testName)), _c('br'), _vm._v(_vm._s(_vm.$t('LNG_DISCIPLINE', this.lang)) + ": " + _vm._s(this.testDiscipline)), _c('br'), _vm._v(_vm._s(_vm.$t('LNG_DATE', this.lang)) + ": " + _vm._s(_vm.testDateFormatted)), _c('br'), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t('LNG_TOTAL_POINTS', this.lang)) + ": " + _vm._s(this.totalPoints) + " pts")])]), _vm._v(" "), (this.testComment !== '') ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_c('pre', [_vm._v(_vm._s(this.testComment))])])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "1",
      "offset": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_GRADE', this.lang)))]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_MIN_POINTS', this.lang)))]), _vm._v(" "), _c('b-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_NUMBER_STUDENTS', this.lang)))])], 1), _vm._v(" "), _vm._l((_vm.bareme), function(b, indexe) {
    return _c('div', [_c('b-row', [_c('b-col', {
      attrs: {
        "cols": "1",
        "offset": "2"
      }
    }, [_vm._v(_vm._s(b.label))]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "1"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "text",
        "placeholder": "Pts"
      },
      on: {
        "change": function($event) {
          return _vm.saveGrade(b, true)
        }
      },
      model: {
        value: (b.min),
        callback: function($$v) {
          _vm.$set(b, "min", $$v)
        },
        expression: "b.min"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      staticClass: "text-left",
      attrs: {
        "cols": "2"
      }
    }, [(b.src1 !== '') ? _c('img', {
      staticClass: "tally",
      attrs: {
        "src": b.src1
      }
    }) : _vm._e(), _vm._v(" "), (b.src2 !== '') ? _c('img', {
      staticClass: "tally",
      attrs: {
        "src": b.src2
      }
    }) : _vm._e(), _vm._v(" "), (b.src3 !== '') ? _c('img', {
      staticClass: "tally",
      attrs: {
        "src": b.src3
      }
    }) : _vm._e(), _vm._v(" "), (b.src4 !== '') ? _c('img', {
      staticClass: "tally",
      attrs: {
        "src": b.src4
      }
    }) : _vm._e()])], 1)], 1)
  }), _vm._v(" "), _c('b-row', {
    staticClass: "mt-5"
  }, [_c('b-col', {
    attrs: {
      "cols": "3",
      "offset": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "type": "button",
      "variant": "evaobj",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.printBareme('printSimpleBareme')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('LNG_PRINT', this.lang)))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "type": "button",
      "variant": "evaobj",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.printBareme('printDetailedBareme')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_PRINT_DETAILLE', this.lang)))])], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d54466e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bareme.vue
// module id = 880
// module chunks = 1